import { render, staticRenderFns } from "./AffiliatesBannerFooter.vue?vue&type=template&id=43080532&scoped=true"
import script from "./AffiliatesBannerFooter.js?vue&type=script&lang=js&external"
export * from "./AffiliatesBannerFooter.js?vue&type=script&lang=js&external"
import style0 from "./AffiliatesBannerFooter.scss?vue&type=style&index=0&id=43080532&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43080532",
  null
  
)

export default component.exports